import { browser as browserLegacy, getBrowserInfo } from '@atlaskit/editor-common/browser';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import type { AIGlobalOptIn, EditorPluginAIProvider } from '../../types/types';
import { createOpenAIModalCommand } from '../decoration/actions';

import { aiQucikstartCommandPluginKey } from './ai-quickstart-command-plugin-key';

export const createAIQuickstartPlugin = (options: {
	aiGlobalOptIn: AIGlobalOptIn;
	editorPluginAIProvider: EditorPluginAIProvider;
	getIntl: PMPluginFactoryParams['getIntl'];
}): SafePlugin => {
	return new SafePlugin({
		key: aiQucikstartCommandPluginKey,
		state: {
			init: (_, state) => ({}),
			apply: () => {},
		},
		props: {
			handleDOMEvents: {
				keydown(view: EditorView, event: KeyboardEvent) {
					const browser = expValEquals('platform_editor_hydratable_ui', 'isEnabled', true)
						? getBrowserInfo()
						: browserLegacy;
					const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
					if (metaKey && event.key === "'") {
						const { editorPluginAIProvider, aiGlobalOptIn } = options;
						const { state, dispatch } = view;

						const configItem = editorPluginAIProvider.baseGenerate;

						const openAIModalCommand = createOpenAIModalCommand({
							state,
							configItem,
							lastTriggeredFrom: 'shortcut',
							triggerMethod: 'shortcut',
							aiGlobalOptIn: aiGlobalOptIn,
							locale: options.getIntl().locale,
						});

						openAIModalCommand(state, dispatch);

						return true;
					}
					return false;
				},
			},
		},
	});
};
